export default {
    keyboardNavigation: {
        bind(el, binding, vnode) {
            el.keyListener = function(event) {
                vnode.context[binding.expression](event);
            };
            document.addEventListener('keydown', el.keyListener);
        },
        unbind(el) {
            document.removeEventListener('keydown', el.keyListener);
        },
    },
    autoDirection: {
        inserted(el, binding, vnode) {
            vnode.context[binding.expression](el);
        },
    },
};
